import { object, string } from 'yup';
import './utils/email';

export const ContactValidation = object().shape({
  firstName: string().required('validations.first_name.required'),
  lastName: string().required('validations.last_name.required'),
  email: string()
    .email('validations.email.format')
    .required('validations.email.required'),
  message: string().required('validations.message.required'),
});
